import styled from "styled-components";
import ThisModalButtonHandler from "../../ThisMainComponent/ThisModalButtonHandler";
import { Colors } from "~/config/Colors";

export const ThisSistemaListaIconButonStyle = styled(ThisModalButtonHandler)`
  position: relative;
  margin-left: 0.5rem;
  width: 1.7rem;
  height: 1.6rem;
  font-size: 1.3em !important;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.3125rem;
  padding: 0;
  ${(props) => `background-color: ${props?.background ? props?.background : Colors.bgColor4};`}
  ${(props) => `color: ${props?.color ? props?.color : Colors.ftColor3} !important;`}
  border: 0;

  :hover {
    ${(props) => `background-color: ${props?.hoverBackground ? props?.hoverBackground : Colors.bgColor5};`}
  }
`;

export const ThisIconButonStyle = styled.button`
  position: relative;
  margin-left: 0.5rem;
  width: 1.7rem;
  height: 1.6rem;
  font-size: 1.3rem !important;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.3125rem;
  padding: 0;
  ${(props) => `background-color: ${props?.background ? props?.background : Colors.Color1};`}
  ${(props) => `color: ${props?.color ? props?.color : Colors.Color7};`}
  border: 0;

  :hover {
    ${(props) => `background-color: ${props?.hoverBackground ? props?.hoverBackground : Colors.Color8};`}
  }
`;
